import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {

  static targets = ["hm0_output"];
  connect() {
    super.connect();
    console.log("DOCUMENTS ENTREPRISE LOAD")
    if ($("#search").length && $("#quick_sort").length) {
      //on est sur la vue list
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });


      $("#filterrific_nom_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".nom_hide").show();
        } else {
          $(".nom_hide").hide();
        }
      });

      $("#filterrific_version_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".version_hide").show();
        } else {
          $(".version_hide").hide();
        }
      });

      $("#filterrific_commentaires_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".commentaires_hide").show();
        } else {
          $(".commentaires_hide").hide();
        }
      });

      $("#filterrific_created_at_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".created_at_hide").show();
        } else {
          $(".created_at_hide").hide();
        }
      });

      $("#filterrific_updated_at_hide").click(function () {
        if ($(this).is(":checked")) {
          $(".updated_at_hide").show();
        } else {
          $(".updated_at_hide").hide();
        }
      });
  }
}

initZindex() {
  let index = [
    ...document.querySelectorAll("#mySidebar DIV"),
    ...document.querySelectorAll("#mySidebar INPUT"),
    ...document.querySelectorAll("#mySidebar I"),
    ...document.querySelectorAll("#mySidebar SPAN"),
    ...document.querySelectorAll("#mySidebar A"),
  ];

  for (let j = 0; j < index.length; j++) {
    index[j].style.zIndex = 100;
  }
}

iniFla() {
  let fields = document.querySelectorAll(".flatpickr");

  for (let j = 0; j < fields.length; j++) {
    fields[j].classList.add("fx-input-date-sidbar-menu");
  }
}

toggle() {
  if (this.isopened != 3) {
    this.initZindex();
    this.isopened = 3;
    this.fct($("#mySidebar").css("width") > "0px").then((res) => {
      if (res == true) {
        this.isopened = 1;
      } else {
        this.isopened = 0;
      }
    });
  } else {
    /*********/
  }
}

fct(isopened) {
  return new Promise((resolve, reject) => {
    if (isopened) {
      $("#table_custom_").css("display", "none");
      this.closeNav().then(() => {
        setTimeout(function () {
          $("#mySidebar").css("position", "unset");
          $("#main").css("position", "unset");
          main.classList.remove("openbtn_left");
          main.classList.add("openbtn_right");
          $("#mySidebar").css("display", "none");
          resolve(false);
        }, 500);
      });
    } else {
      $("#table_custom_").css("display", "");

      this.openNav().then(() => {
        $("#mySidebar").css("position", "absolute");
        $("#main").css("position", "absolute");
        $("#main").css("marginTop", "0px");
        $("#mySidebar").css("display", "block");
        main.classList.add("openbtn_left");
        main.classList.remove("openbtn_right");
        resolve(true);
      });
    }
  });
}

openNav() {
  return new Promise((resolve, reject) => {
    document.getElementById("mySidebar").style.width = "366.8px";
    document.getElementById("main").style.marginRight = "366.8px";
    resolve(true);
  });
}

closeNav() {
  return new Promise((resolve, reject) => {
    document.getElementById("mySidebar").style.width = "0px";
    document.getElementById("main").style.margin = "0px";
    resolve(true);
  });
}

  
  get current_app() {
    return this.data.get("app");
  }
  get note_de_frai_id() {
    return this.data.get("note_de_fraiid");
  }
  get url_solution() {
    return this.data.get("urlsolution");
  }
}




// HM
// - frais

// Colonnes fixes sur le mode liste
// - N°
// - Collaborateur
// - Statut
// - Réglée (o/n)
// - Ajouter
// - Dépenses

// Colonnes qu'on peut ajouter
// - Année ==>
// - Mois==>
// - Entité 
// - Virement immédiat
// - Devise de l'entité
// - Total HT (devise entité)
// - Total TVA (devise entité)
// - Total TTC (devise entité)
// - Total HT refacturable (devise entité)
// - Total à rembourser (devise entité)
// - Total HT (devise groupe)
// - Total TVA (devise groupe)
// - Total TTC (devise groupe)
// - Total à rembourser (devise groupe)
// - Créé le
// - Créé par
// - Soumis le
// - Soumis par
// - Validé le
// - Validé par